import { h } from "preact";

import { classNames } from "../helpers.js";

import Button from "./Button.jsx";
import Icon from "./Icon.jsx";

export default function IconButton({
  children,
  onClick,
  iconClass,
  trackingName,
  azure,
  ...props
}) {
  return (
    <Button
      {...props}
      trackingName={trackingName}
      small
      text
      onClick={onClick}
      class={classNames(
        "icon-button",
        props.class,
        azure && "icon-button--azure"
      )}
    >
      <Icon class={classNames("icon-button__icon", props.iconClass)}>
        {children}
      </Icon>
    </Button>
  );
}
